import PolicyInfo from './PolicyInfo';
export default PolicyInfo;
